import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.profile.actions;
//VERIFY IF THE JWT IS SET
const getProfileActionsStatus = createSelector(getData, actions => actions);
export default getProfileActionsStatus;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getProfileActionsStatus.js